<template>
	<div>
		<CCard class="p-2">
			<form ref="form" @submit.prevent="submit">
				<CCardHeader>
					<CRow class="ml-3 mr-3">
				
						<CCol lg="6">
							<h5 v-if="!editMode">Create Trucker Settlement</h5>
							<h5 v-else>Update Trucker Settlement / {{dataParams.invoice_no}}</h5>
						</CCol>
						<CCol lg="6">
							<div style="text-align: right">
								<CButton size="sm" class="btn btn-ghost-dark" @click="backToTable()"><i
										class="fa fa-close"></i> Cancel</CButton> &nbsp;
								<CButton size="sm" color="info" id="btn_submit" type="submit"><i class="fa fa-save"></i>
									Save</CButton>
							</div>
						</CCol>
					</CRow>
				</CCardHeader>
				<CCardBody>
					<CCard class="p-2">
						<CRow class="ml-3 mr-3">
							<CCol lg="12">
								<strong style="font-size:13px" class="text-dark">Trucker Settlement Information</strong>
							</CCol>
						</CRow>
						<br />
					
						<CCol lg="4">
							<h4 class="text-success" style="text-align: right;" v-if="isLoading">Uploading...({{uploadPercentage}}%)</h4>
						</CCol> 	
							<CRow class="ml-3 mr-3"> 
							<CCol lg="6">        
										<div class="form-group"> 
											<label>Vendor/Trucker <span class="text-danger">*</span></label>
											<v-select 
												label="vendor_name" 
												:options="vendorList.data"
												:reduce="item => item.id"
												v-model="dataParams.vendor_id"
												placeholder="-Select Vendor/Trucker-" 
											>
												<template #search="{attributes, events}">
													<input
														class="vs__search"
														:required="!dataParams.vendor_id"
														v-bind="attributes"
														v-on="events"
													/>
												</template>
											</v-select>
										</div>
							</CCol>
							
							<CCol lg="3">
										<div class="form-group"> 
											<label>Tax Type <span class="text-danger">*</span></label>
											<v-select 
												label="setting_name" 
												:options="[
													{
														setting_name: 'VAT',
														id: 'VAT'
													},
													{
														setting_name: 'Non-VAT',
														id: 'NON VAT'
													},
												]"
												:reduce="item => item.id"
												v-model="dataParams.tax_type"
												placeholder="-Select tax type-" 
											>
												<template #search="{attributes, events}">
													<input
														class="vs__search"
														:required="!dataParams.tax_type"
														v-bind="attributes"
														v-on="events"
													/>
												</template>
											</v-select>
										</div>
							</CCol>
							<CCol lg="3">
										<div class="form-group"> 
											<label>Status <span class="text-danger">*</span></label>
											<v-select 
												label="setting_name" 
												:options="[
													{
														setting_name: 'CANCELLED',
														id: 'CANCELLED'
													},
													{
														setting_name: 'BILLED',
														id: 'BILLED'
													},
													{
														setting_name: 'UNBILLED',
														id: 'UNBILLED'
													}
												]"
												:reduce="item => item.id"
												v-model="dataParams.status"
												placeholder="-Select Status-" 
											>
												<template #search="{attributes, events}">
													<input
														class="vs__search"
														:required="!dataParams.status"
														v-bind="attributes"
														v-on="events"
													/>
												</template>
											</v-select>
										</div>
							</CCol>
							<CCol lg="3">        
										<div class="form-group"> 
											<label>Customer </label>
											<v-select 
												label="customer_name" 
												:options="customerList.data"
												:reduce="item => item.id"
												v-model="dataParams.customer_id"
												placeholder="-Select customer-" 
											>
												
											</v-select>
										</div>
							</CCol>
								<CCol lg="3">
									<div class="form-group"> 
										<label class="mb-1"> Truck Type<span class="text-danger"> </span></label>
										<v-select 
											label="setting_name" 
											:options="vehicleTypeList.data"
											:reduce="item => item.id"
											v-model="dataParams.vehicle_type_id"
											placeholder="-Select-" 
										
											
										>
											
										</v-select>
									</div>
								</CCol> 
								<CCol lg="3">
										<CInput
										@keypress="isNumber($event)"	
										label="Admin Fee (%)"
										placeholder="Enter admin fee percentage"
										v-model="dataParams.admin_fee" 
										/>
							</CCol>
							<CCol lg="3">
										<CInput
										
										label="Ref. No."
										placeholder="Enter ref no."
										v-model="dataParams.ref_no" 
										/>
							</CCol>
							
							
							</CRow>
								
					
							<CRow class="ml-3 mr-3">
								<CCol lg="12">
									<strong style="font-size:13px" class="text-dark">Covered Trips</strong>
								</CCol>
							</CRow>
							<br />
								
						<CRow class="ml-3 mr-3">
									<CCol lg="3">
										<div class="form-group">
											<label for="exampleInputEmail1">Delivery Date From <span class="text-danger">*</span></label>
											
											<Datepicker 
												input-class="form-control bg-white" 
												v-model="dataParams.delivery_date_from"
												placeholder="Delivery Date From" 
												:typeable="true" 
												required 
											>
											</Datepicker>  
											<!-- <Datetime format="MM-DD-YYYY" v-model="dataParams.delivery_date_from" required></Datetime> -->
										</div> 
									</CCol>  
									<CCol lg="3">
										<div class="form-group">
											<label for="exampleInputEmail1">Delivery Date To <span class="text-danger">*</span></label>
											<Datepicker 
												input-class="form-control bg-white" 
												v-model="dataParams.delivery_date_to"
												placeholder="Delivery Date To" 
												:typeable="true" 
												required 
											>
											</Datepicker>  
											
											<!-- <Datetime format="MM-DD-YYYY" v-model="dataParams.delivery_date_to" required></Datetime> -->
										</div> 
									</CCol>  
									
									<CCol lg="3">
										<div class="form-group"> 
											<label>Origin</label>
											<v-select 
												label="setting_name" 
												:options="originList.data"
												:reduce="item => item.id"
												v-model="dataParams.origin_id"
												placeholder="-Select origin-" 
											>
												
											</v-select>
										</div>
										
									</CCol> 
									<CCol lg="3">
										<div class="form-group"> 
											<label>Depot</label>
											<v-select 
												:disabled="depot_id != null"
												label="setting_name" 
												:options="depotList.data"
												:reduce="item => item.id"
												v-model="dataParams.depot_id"
												placeholder="-Select depot-" 
											>
												
											</v-select>
										</div>
									</CCol>
									<CCol lg="12">
										<div style="text-align: right" class="mt-4">  
											<CButton size="sm" color="secondary" class="px-3" @click="clearSearch">Clear</CButton> &nbsp;
											<CButton size="sm" color="info" @click="validate"><i class="icon-magnifier"></i> Search</CButton> 
											
										</div>
									</CCol>
									
							</CRow>  
				
					</CCard>
					<CRow>
					<CCol lg="12">
						<CDataTable
						:items="displayedBooking"
						:fields="tableFields"
						class="table-borderless"
						:loading="searching"
						>
      				<!-- Currency formatting -->
					<template #subcon_rate="{ item }">
						<td class="font-weight-bold">
						{{ item.subcon_rate | number_format('currency') }}
						</td>
					</template>

					<template #toll_fee="{ item }">
						<td>
						{{ item.toll_fee | number_format('currency') }}
						</td>
					</template>
					<template #extra_helper="{ item }">
						<td>
						{{ item.extra_helper | number_format('currency') }}
						</td>
					</template>
					<template #backload_fee="{ item }">
						<td>
						{{ item.backload_fee | number_format('currency') }}
						</td>
					</template>
					<template #demurrage_fee="{ item }">
						<td>
						{{ item.demurrage_fee | number_format('currency') }}
						</td>
					</template>


					<template #parking_fee="{ item }">
						<td >
						{{ item.parking_fee | number_format('currency') }}
						</td>
					</template>

					<template #other_expenses="{ item }">
						<td class="text-muted">
						{{ item.other_expenses | number_format('currency') }}
						</td>
					</template>
					<template #other_deductions="{ item }">
						<td class="text-muted">
						{{ item.other_deductions | number_format('currency') }}
						</td>
					</template>
					<template #admin_fee="{ item }">
					<td class="text-muted">
							{{ item.admin_fee | number_format('currency') }}
					</td>
				</template>

					<template #total_amount="{ item }">
						<td >
						{{ item.total_amount | number_format('currency') }}
						</td>
					</template>

					<template #payment_amount="{ item }">
						<td class="text-success font-weight-bold">
						{{ item.payment_amount | number_format('currency') }}
						</td>
					</template>
					</CDataTable>

					<!-- Pagination -->
					<CPagination
					class="mt-2"
					:active-page.sync="currentPage"
					:pages="Math.ceil(bookingList.total / 20)"
					:activePage="currentPage"
					@update:activePage="updatePage"
					/>
					</CCol>
					</CRow>

			<!-- ✅ SUMMARY BELOW TABLE -->
				<CRow class="ml-3 mr-3 mt-3 justify-content-end">
					<CCol lg="4" md="6" sm="12">
						<CCard class="shadow-sm">
						<CCardHeader class="font-weight-bold text-center">
							Settlement Summary
						</CCardHeader>

						<CCardBody class="p-2">
						<ul class="list-group list-group-flush small">

					<!-- SUBCON -->
					<li class="list-group-item d-flex justify-content-between">
						Subcon Total
						<strong>{{ summary.subconTotal | number_format('currency') }}</strong>
					</li>

						<!-- VATABLE FEES -->
						<li
						v-if="
							companyFlags.isVat &&
							!companyFlags.isMarvel &&
							summary.vatableFeesTotal > 0
						"
						class="list-group-item d-flex justify-content-between"
						>


							<span>
							VATable Charges
							<small class="text-muted d-block">

								<template v-if="companyFlags.isMarvel">
								Subcon
								</template>

								<template v-else-if="companyFlags.isRoadwise">
								Subcon, Toll, Extra Helper, Backload, Demurrage
								</template>

								<template v-else>
								Subcon, Toll, Parking, Extra Helper, Backload, Demurrage, Other Fees, Other Deductions
								</template>

							</small>
							</span>
							<strong>
							{{ summary.vatableFeesTotal | number_format('currency') }}
							</strong>
						</li>

						<!-- VAT -->
						<li
							v-if="companyFlags.isVat"
							class="list-group-item d-flex justify-content-between"
						>
							VAT (12%)
							<strong>{{ summary.vat | number_format('currency') }}</strong>
						</li>

						<!-- WITHHOLDING -->
						<li
							v-if="companyFlags.isVat"
							class="list-group-item d-flex justify-content-between"
						>
							Withholding Tax (2%)
							<strong class="text-danger">
							-{{ summary.withholding | number_format('currency') }}
							</strong>
						</li>
						<!-- ADMIN FEE -->
						<li
						v-if="summary.adminFee > 0 && !companyFlags.isMarvel"
						class="list-group-item d-flex justify-content-between"
						>
						<span>
							Admin Fee
							<small class="text-muted d-block">
							{{ dataParams.admin_fee || 0 }}%
							<template v-if="companyFlags.isRoadwise">
								of Subcon + Helpers + Backload + Demurrage
							</template>
							<template v-else>
								of Subcon Rate
							</template>
							</small>
						</span>
						<strong class="text-danger">
							-{{ summary.adminFee | number_format('currency') }}
						</strong>
						</li>


						<!-- OTHER FEES (NON-VAT) -->
						<li class="list-group-item d-flex justify-content-between">
							<span>
							Other Charges
							<small class="text-muted d-block">

								<template v-if="companyFlags.isMarvel">
								Toll, Parking, Other Fee, Other Deductions (Non-VAT)
								</template>

								<template v-else-if="companyFlags.isRoadwise">
								Other Fees, Other Deductions (Non-VAT)
								</template>

								<template v-else>
								—
								</template>

							</small>
							</span>
							<strong>
							{{ summary.otherFeesTotal | number_format('currency') }}
							</strong>
						</li>

						<!-- TOTAL -->
						<li class="list-group-item d-flex justify-content-between">
							Total Amount
							<strong>{{ summary.totalAmount | number_format('currency') }}</strong>
						</li>

						<!-- PAYMENT -->
						<li class="list-group-item d-flex justify-content-between font-weight-bold">
							PAYMENT AMOUNT
							<span class="text-success">
							{{ summary.paymentAmount | number_format('currency') }}
							</span>
						</li>

			</ul>


      </CCardBody>
    </CCard>
  </CCol>
				</CRow>



				</CCardBody>
			</form>
		</CCard>
	</div>
</template>
<script> 
import config from '../../config.js';
import axios from '../../axios';
import Swal from 'sweetalert2';
import Search from './search'
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import '../../style.css';
import Datetime from 'vuejs-datetimepicker'; 
import moment from 'moment';

export default {
	mounted(){  

		this.getCustomer(); 
		this.getVendor();  
		this.getOrigin();   
		this.getDepot();
		this.getVehicleType();
		 
		if(this.$route.params.id != undefined){
			this.editMode = true;
		} 
		if(this.$route.params.id){
			this.getData();
		} 

	},
	data(){
		return{
			depot_id: JSON.parse(window.localStorage.getItem('user_data')).depot_id,
			currentPage: 1,
			formModal: false,
			showViewModal: false,
			dataList: [],
			dataListInactive: [],
			depotName: "",  
			dataParams: {
				customer_id: "",
				vendor_id: "",
				origin_id: "", 
				vehicle_type_id:"",
				ref_no: "",
				status: "UNBILLED",
				tax_type: "VAT",
				delivery_date_from: "",
				delivery_date_to: "",
				total_amount: 0.00,
				depot_id: JSON.parse(window.localStorage.getItem('user_data')).depot_id != null ? JSON.parse(window.localStorage.getItem('user_data')).depot_id : null,
				// date_billed: "",
			},
			editMode: false,
			selectedRow: {},
			vendorList: {
				data: []
			},
			vehicleTypeList: {
				data: []
			},
			makerModelList: {
				data: []
			},
			
			
			isLoading: false,
			uploadPercentage: 0,
			config,
				vehicleTypeList: {
				data: []
			},
			customerList: {
				data: []
			},
			vendorList: {
				data: []
			},
			bookingTypeList: {
				data: []
			},
			commodityTypeList: {
				data: []
			},
			depotList: {
				data: []
			},
			originList: {
				data: []
			},
			destinationList: {
				data: []
			},
			vehicleList: {
				data: []
			},
			driverList: {
				data: []
			},
			depotList: {data:[]},
			fields:  [
				{
					key: 'booking_no', 
					label: 'Booking #'
				},
				{
					key: 'customer_id_label', 
					label: 'Customer'
				}, 
				
				{
					key: 'delivery_date_label', 
					label: 'Delivery Date'
				},   
				
				{
					key: 'origin_id_label', 
					label: 'Origin'
				}, 
				{
					key: 'depot_name',
					label : 'Depot'
				},
			
				{
					key: 'subcon_rate', 
					label: 'Subcon Rate'
				},
				{
					key: 'toll_fee', 
					label: 'Toll Fee'
				},
					{
					key: 'extra_helper', 
					label: 'Extra Helper'
				},
					{
					key: 'backload_fee', 
					label: 'Backload Fees'
				},
				{
					key: 'demurrage_fee', 
					label: 'Demurrage Fees'
				},
				{
					key: 'other_expenses', 
					label: 'Other Fees'
				},
				{
					key: 'parking_fee', 
					label: 'Parking Fee'
				},
				{
					key: 'other_deductions', 
					label: 'Other Deductions'
				},
				{
					key: 'admin_fee', 
					label: 'Admin Fee'
				},

				{
					key: 'total_amount', 
					label: 'Total Amount'
				}
			],
			fields_marvel:  [
				{
					key: 'booking_no', 
					label: 'Booking #'
				},
				{
					key: 'customer_id_label', 
					label: 'Customer'
				}, 
				
				{
					key: 'delivery_date_label', 
					label: 'Delivery Date'
				},   
				{
					key: 'plate_no', 
					label: 'Plate #'
				}, 
				{
					key: 'origin_id_label', 
					label: 'Origin'
				}, 
				{
					key: 'depot_name',
					label : 'Depot'
				},
					{
					key: 'client_rate', 
					label: 'Client Rate'
				},
				// {
				// 	key: 'no_of_trips', 
				// 	label: 'No. of trips'
				// }, 
					{
					key: 'admin_fee', 
					label: 'Admin Fee'
				},
				{
					key: 'subcon_rate', 
					label: 'Subcon Rate'
				},
				{
					key: 'toll_fee', 
					label: 'Toll Fee'
				},
					{
					key: 'parking_fee', 
					label: 'Parking Fee'
				},
				{
					key: 'other_expenses', 
					label: 'Other Fees'
				},
				{
					key: 'other_deductions', 
					label: 'Other Deductions'
				},
			
				{
					key: 'total_amount', 
					label: 'Total Amount'
				},
				{
					key: 'payment_amount', 
					label: 'Payment Amount'
				}
			],
			fields_roadwise:  [
				{
					key: 'booking_no', 
					label: 'Booking #'
				},
				{
					key: 'customer_id_label', 
					label: 'Customer'
				}, 
				 
				{
					key: 'delivery_date_label', 
					label: 'Delivery Date'
				},   
				{
					key: 'plate_no', 
					label: 'Plate #'
				}, 
				{
					key: 'origin_id_label', 
					label: 'Origin'
				}, 
				{
					key: 'depot_name',
					label : 'Depot'
				},
				
				{
					key: 'subcon_rate', 
					label: 'Subcon Rate'
				},
				
					{
					key: 'extra_helper', 
					label: 'Extra Helper'
				},
					{
					key: 'backload_fee', 
					label: 'Backload Fees'
				},
				{
					key: 'demurrage_fee', 
					label: 'Demurrage Fees'
				},
				{
					key: 'toll_fee', 
					label: 'Toll Fees'
				},
				{
					key: 'other_expenses', 
					label: 'Other Fees'
				},
				{
					key: 'other_deductions', 
					label: 'Other Deductions'
				},
				{
					key: 'admin_fee', 
					label: 'Admin Fee'
				},
				{
					key: 'total_amount', 
					label: 'Total Amount'
				}
			],
			displayedBooking: [],
			bookingList: {
				data: [],
				total: 0
			},
			disableSubmit: false,
			searching: false
		}
	},
	computed: {
				companyFlags() {
					const name =
					JSON.parse(localStorage.getItem("user_data"))?.company?.company_name
						?.toLowerCase() ?? "";

					return {
					isMarvel: name.includes("marvel"),
					isRoadwise: name.includes("roadwise"),
					isVat: this.dataParams.tax_type === "VAT"
					};
				},
			
		summary() {
					const bookings = this.bookingList.data || [];

					let subconTotal = 0;
					let vatableFeesTotal = 0;
					let otherFeesTotal = 0;
					let vatTotal = 0;
					let withholdingTotal = 0;
					let adminFeeTotal = 0;
					let totalAmount = 0;
					let marvelNonVatTotal = 0;

					const name =
						JSON.parse(localStorage.getItem("user_data"))?.company?.company_name
						?.toLowerCase() ?? "";

					const isMarvel = name.includes("marvel");
					const isRoadwise = name.includes("roadwise");
					const isVat = this.dataParams.tax_type === "VAT";

					const adminRate =
						Number(this.dataParams.admin_fee || 0) / 100;

					bookings.forEach(b => {
						const subcon = Number(b.subcon_rate || 0);
						const toll = Number(b.toll_fee || 0);
						const parking = Number(b.parking_fee || 0);
						const extra = Number(b.extra_helper || 0);
						const backload = Number(b.backload_fee || 0);
						const demurrage = Number(b.demurrage_fee || 0);
						const other = Number(b.other_expenses || 0);
						const otherDed = Number(b.other_deductions || 0);

						/* ROADWISE */
						if (isRoadwise) {
						const vatable = subcon + extra + backload + demurrage + toll;
						const nonVat = other + otherDed;

						subconTotal += subcon;
						vatableFeesTotal += vatable;
						otherFeesTotal += nonVat;

						const adminBase =
							(subcon + extra + backload + demurrage) *
							(isVat ? 1.12 : 1);

						adminFeeTotal += adminBase * adminRate;

						if (isVat) {
							vatTotal += vatable * 0.12;
							withholdingTotal += vatable * 0.02;
							totalAmount += vatable * 1.12 + nonVat;
						} else {
							totalAmount += vatable + nonVat;
						}
						return;
						}

						/* MARVEL */

						if (isMarvel) {
						const vatable = subcon;
						const nonVat =
							toll +
							parking +
							other +
							otherDed;

						subconTotal += subcon;
						vatableFeesTotal += vatable;
						otherFeesTotal += nonVat;

						// track NON-VAT total for payment computation
						marvelNonVatTotal += nonVat;

						// ADMIN FEE (DISPLAY ONLY)
						const clientRate = Number(b.client_rate || 0);
						adminFeeTotal += clientRate - subcon;

						if (isVat) {
							const vat = vatable * 0.12;
							const withholding = vatable * 0.02;

							vatTotal += vat;
							withholdingTotal += withholding;

							// TOTAL = subcon x 1.12 - 2% tax
							const total = (vatable * 1.12) - withholding;
							totalAmount += total;
						} else {
							// NON-VAT MARVEL
							totalAmount += vatable;
						}

						return;
						}



						/* OTHER COMPANIES */
						const vatable =
						subcon + extra + backload + demurrage +
						toll + parking + other + otherDed;

						subconTotal += subcon;
						vatableFeesTotal += vatable;

						const adminBase = isVat ? subcon * 1.12 : subcon;
						adminFeeTotal += adminBase * adminRate;

						if (isVat) {
						vatTotal += vatable * 0.12;
						withholdingTotal += vatable * 0.02;
						totalAmount += vatable * 1.12;
						} else {
						totalAmount += vatable;
						}
					});

				const paymentAmount = isMarvel
					? totalAmount - marvelNonVatTotal
					: totalAmount - withholdingTotal - adminFeeTotal;



					return {
						subconTotal: subconTotal.toFixed(2),
						vatableFeesTotal: vatableFeesTotal.toFixed(2),
						otherFeesTotal: otherFeesTotal.toFixed(2),
						vat: vatTotal.toFixed(2),
						withholding: withholdingTotal.toFixed(2),
						adminFee: adminFeeTotal.toFixed(2),
						totalAmount: totalAmount.toFixed(2),
						paymentAmount: paymentAmount.toFixed(2)
					};
					},



		
				tableFields() {
						const companyName =
							JSON.parse(window.localStorage.getItem("user_data"))?.company?.company_name
							?.toLowerCase() ?? "";

						if (companyName.includes('roadwise')) {
							return this.fields_roadwise;
						}

						if (companyName.includes('marvel')) {
							return this.fields_marvel;
						}

						return this.fields;
						}

				},
				watch: {
				"dataParams.admin_fee": {
					handler() {
					this.recomputeTable();
					},
					immediate: false
				},

				"dataParams.tax_type": {
					handler() {
					this.recomputeTable();
					},
					immediate: false
				}
				},

	name: 'Tables',
	components: {Search, Datepicker, vSelect, Datetime},
	methods: {  
	 	 getVehicleType(){

	    	axios.get(config.api_path+'/reference/settings-list',{
            params:{
              setting_type:'vehicle_type'
            }
       		   })
	    	.then(response => {
	    		this.vehicleTypeList = response.data; 
	    	})

	    },
		getDepot(){

          axios.get(config.api_path+'/setting?setting_type=depot&page=1&limit=100000')
          .then(response => {
            this.depotList = response.data;
            this.depotList.data = this.depotList.data.map((value, index)=>{
              value.value = value.id;
              value.label = value.setting_name;
              return value;
            })

            console.log(this.depotList)
          })

        }, 
		updatePage(data){
			this.currentPage = data; 
			this.displayedBooking = [...this.bookingList.data];  
			if(this.currentPage > 1){
				this.displayedBooking.splice(0, ((this.currentPage-1) * 20));
				this.displayedBooking.splice(((this.currentPage-1) * 20), this.bookingList.data.length) 
			}
			else{ 
				this.displayedBooking.splice(20, this.bookingList.data.length) 
			}
		}, 
		 backToTable(){
	    	this.$router.push('/main/trucker_settlement')
	    },

 
	    submit(){

	    	if(this.disableSubmit){
	    		this.getBookings();
	    		return;
	    	}

	    	if(this.bookingList.data.length == 0){
	    		Swal.fire({
					title: 'Ooooppss!',
					text: "No bookings found!",
					icon: 'warning', 
				})
				return;
	    	}
	    	if(this.dataParams.origin_id == ""){
	    		this.dataParams.origin_id = null;
	    	} 		

	    	this.dataParams.bookings = this.bookingList.data.map((value, index)=>{return{id: value.id}});

			for (const key in this.dataParams) {
				if (this.dataParams.hasOwnProperty(key)) {
					this.dataParams[key] = this.dataParams[key] ? this.dataParams[key] : null;
				}
			}

	    	var ax = {};
	    	this.dataParams.delivery_date_from = moment(this.dataParams.delivery_date_from).startOf('day').unix();
	    	this.dataParams.delivery_date_to = moment(this.dataParams.delivery_date_to).startOf('day').unix()+(86399);
	    	console.log(this.dataParams);
			
	    	if(this.editMode){
	    		ax = axios.put(config.api_path+"/trucker_settlement/"+this.$route.params.id, this.dataParams)
	    	}
	    	else{
	    		ax = axios.post(config.api_path+"/trucker_settlement", this.dataParams)
	    	}
			this.$showLoading(true);
	    	ax.then(response => {
				this.$showLoading(false);
	    		var text = 'Trucker settlement successfully added!';
	    		if(this.editMode){
	    			text = 'Trucker settlement successfully updated!';
	    		}
	    		
	    		this.formModal = false
	    		this.editMode = false;
	    		this.dataParams = {
					customer_id: "",
					origin_id: "",
					vendor_id: "",
					vehicle_type_id:"",
					admin_fee:"",
					ref_no: "",
					status: "",
					tax_type: "vat",
					delivery_date_from: "",
					delivery_date_to: "",
					total_amount: "",
					vehicleTypeList: "",
					// date_billed: "",
					bookings: []
				}
				Swal.fire({
					title: 'Success!',
					text,
					icon: 'success', 
				})
				.then((result) => { 
					this.bookingList.data = [];
	    		this.$router.push('/main/view_trucker_settlement/'+response.data.data.id)
				})
				
	    	})
			.catch(err => {
				this.$showLoading(true);
			})
	    }, 


		getCustomer() {
			axios.get(config.api_path + '/reference/customer-list', {
				params: {
					show_all: true
				}
			})
				.then(response => {
					this.customerList = response.data;
				})
		},

	    getVendor(){

	    	axios.get(config.api_path+'/vendor?page=1&limit=10000000')
	    	.then(response => {
	    		this.vendorList = response.data;
	    		this.vendorList.data = this.vendorList.data.filter((value, index)=>{
	    			return value.status == 'active' 
					&& value.vendor_type_name.setting_name.toLowerCase() == 'trucker'
					|| value.vendor_type_name.setting_name.toLowerCase() == 'trucking services';
	    		}) 
	    	})

	    }, 

	    getOrigin() {
			axios.get(config.api_path + '/reference/settings-list', {
				params: {
					setting_type: 'origin'
				}
			})
				.then(response => {
					this.originList = response.data;
				})
		},
	    validate(){
	    	this.disableSubmit = true;
			document.getElementById('btn_submit').click();
	    },
		recomputeTable() {
			if (!Array.isArray(this.bookingList.data) || !this.bookingList.data.length) {
			return;
			}

			const result = this.mapBookings(this.bookingList.data);

			// update table
			this.bookingList.data = result.bookings;
			this.displayedBooking = [...result.bookings];

			// update totals (if bound to UI)
			this.dataParams.total_amount = result.total_amount;
			this.dataParams.sub_total = result.sub_total;
			this.dataParams.tax_computation = result.tax_computation;
		},

		mapBookings(bookings = []) {
						let over_total_amount = 0;
						let sub_total = 0;
						let tax_computation = 0;

						const companyName =
							JSON.parse(window.localStorage.getItem("user_data"))
							?.company?.company_name?.toLowerCase() ?? "";

						const isRoadwise = companyName.includes("roadwise");
						const isMarvel = companyName.includes("marvel");
						const isVat = this.dataParams.tax_type === "VAT";

						const adminRate =
							Number(this.dataParams.admin_fee || 0) / 100;

						const mapped = bookings.map(value => {

							/* ================= LABELS ================= */
							value.customer_id_label = value.customer?.customer_name ?? "N/A";
							value.origin_id_label = value.origin?.setting_name ?? "N/A";
							value.depot_name = value.depot?.setting_name ?? "N/A";
							value.plate_no = value.vehicle?.plate_no ?? "N/A";

							value.delivery_date_label = value.delivery_date
							? moment.unix(value.delivery_date).format("MM/DD/YYYY")
							: "N/A";

							/* ================= FEES ================= */
							const subcon_rate = Number(value.subcon_rate || 0);
							const toll = Number(value.billable?.toll_fee || 0);
							const parking = Number(value.billable?.parking_fee || 0);
							const extraHelper = Number(value.billable?.extra_helper || 0);
							const backload = Number(value.billable?.backload_fee || 0);
							const demurrage = Number(value.billable?.demurrage_fee || 0);
							const other = Number(value.billable?.other_expenses || 0);
							const otherDeductions = Number(value.billable?.other_deductions || 0);

							Object.assign(value, {
							subcon_rate,
							toll_fee: toll,
							parking_fee: parking,
							extra_helper: extraHelper,
							backload_fee: backload,
							demurrage_fee: demurrage,
							other_expenses: other,
							other_deductions: otherDeductions
							});

							/* ================= ROADWISE ================= */
							if (isRoadwise) {
							const vatableBase =
								subcon_rate +
								extraHelper +
								backload +
								demurrage +
								toll;

							const nonVatFees = other + otherDeductions;

							const adminFeeBase =
								(subcon_rate + extraHelper + backload + demurrage) *
								(isVat ? 1.12 : 1);

							const adminFee = adminFeeBase * adminRate;

							if (isVat) {
								const vat = vatableBase * 0.12;
								const withholding = vatableBase * 0.02;

								const totalAmount =
								vatableBase * 1.12 + nonVatFees;

								const paymentAmount =
								totalAmount - withholding - adminFee;

								tax_computation += vat;
								over_total_amount += totalAmount;

								Object.assign(value, {
								admin_fee: adminFee.toFixed(2),
								total_amount: totalAmount.toFixed(2),
								payment_amount: paymentAmount.toFixed(2)
								});
							} else {
								const totalAmount = vatableBase + nonVatFees;
								const paymentAmount = totalAmount - adminFee;

								over_total_amount += totalAmount;

								Object.assign(value, {
								admin_fee: adminFee.toFixed(2),
								total_amount: totalAmount.toFixed(2),
								payment_amount: paymentAmount.toFixed(2)
								});
							}

							sub_total += vatableBase + nonVatFees;
							return value;
							}

					

			/* ================= MARVEL ================= */
			if (isMarvel) {
			const vatableBase = subcon_rate;

			const nonVatFees =
				toll +
				parking +
				other +
				otherDeductions;

			// ✅ ADMIN FEE (DISPLAY ONLY)
			const clientRate = Number(value.client_rate || 0);
			const adminFee = clientRate - subcon_rate;

			let totalAmount = 0;
			let paymentAmount = 0;

			if (isVat) {
				const vat = vatableBase * 0.12;
				const withholding = vatableBase * 0.02;

				// ✅ TOTAL = subcon x 1.12 - 2% tax
				totalAmount = (vatableBase * 1.12) - withholding;

				// ✅ NET PAY = TOTAL - NON-VAT FEES
				paymentAmount = totalAmount - nonVatFees;

				tax_computation += vat;
			} else {
				// ✅ NON-VAT MARVEL
				totalAmount = vatableBase;
				paymentAmount = totalAmount - nonVatFees;
			}

			over_total_amount += totalAmount;
			sub_total += vatableBase;

			Object.assign(value, {
				admin_fee: adminFee.toFixed(2),      // display only
				total_amount: totalAmount.toFixed(2),
				payment_amount: paymentAmount.toFixed(2)
			});

			return value;
			}



							/* ================= OTHER COMPANIES ================= */
							const vatableBase =
							subcon_rate +
							extraHelper +
							backload +
							demurrage +
							toll +
							parking +
							other +
							otherDeductions;

							const adminFeeBase =
							isVat ? subcon_rate * 1.12 : subcon_rate;

							const adminFee = adminFeeBase * adminRate;

							if (isVat) {
							const vat = vatableBase * 0.12;
							const withholding = vatableBase * 0.02;

							const totalAmount = vatableBase * 1.12;
							const paymentAmount =
								totalAmount - withholding - adminFee;

							tax_computation += vat;

							Object.assign(value, {
								admin_fee: adminFee.toFixed(2),
								total_amount: totalAmount.toFixed(2),
								payment_amount: paymentAmount.toFixed(2)
							});
							} else {
							const totalAmount = vatableBase;
							const paymentAmount = totalAmount - adminFee;

							Object.assign(value, {
								admin_fee: adminFee.toFixed(2),
								total_amount: totalAmount.toFixed(2),
								payment_amount: paymentAmount.toFixed(2)
							});
							}

							over_total_amount += Number(value.total_amount);
							sub_total += vatableBase;

							return value;
						});

						return {
							bookings: mapped,
							total_amount: over_total_amount.toFixed(2),
							sub_total: sub_total.toFixed(2),
							tax_computation: tax_computation.toFixed(2)
						};
			},



		getBookings() {
			this.searching = true;

			const from = moment(this.dataParams.delivery_date_from)
				.startOf('day')
				.unix();
			const to = moment(this.dataParams.delivery_date_to)
				.startOf('day')
				.unix() + 86399;

			const isEdit = !!this.$route.params.id;
			const currentSettlementId = this.$route.params.id ?? null;

				axios.get(`${config.api_path}/booking`, {
					params: {
						is_subcon: 1,
						trucker_settlement_id: currentSettlementId,
						status: 'completed',
						from,
						to,
						vehicle_type_id: this.dataParams.vehicle_type_id || "",
						origin_id: this.dataParams.origin_id || "",
						customer_id: this.dataParams.customer_id || "",
						vendor_id: this.dataParams.vendor_id || "",
						depot_id: this.dataParams.depot_id ?? null,
						page: 1,
						limit: 1000000
					}
				})
					.then(response => {
						this.disableSubmit = false;

						let bookings = response.data.data ?? [];

		// ✅ FILTER ONLY WHEN CREATING (NOT EDITING)
			if (!isEdit) {
				bookings = bookings.filter(b => {
					// exclude bookings already assigned to ANY settlement
					return !b.trucker_settlement_id && !b.trucker_settlement;
				});
			}

					this.bookingList.data = bookings;
					this.bookingList.total = bookings.length;

					const result = this.mapBookings(bookings);

					this.bookingList.data = result.bookings;
					this.displayedBooking = [...result.bookings];

					this.dataParams.total_amount = result.total_amount;
					this.dataParams.sub_total = result.sub_total;
					this.dataParams.tax_computation = result.tax_computation;

					this.searching = false;
				})
				.catch(err => {
					console.error(err);
					this.searching = false;
					this.disableSubmit = false;
				});
			},

	  getData() {
			this.$showLoading(true);

			axios.get(config.api_path + "/trucker_settlement/" + this.$route.params.id)
			.then(response => {
				this.$showLoading(false);

				this.dataParams = response.data.data;

				this.dataParams.delivery_date_from =
					moment(this.dataParams.delivery_date_from * 1000).format('MM-DD-YYYY');
				this.dataParams.delivery_date_to =
					moment(this.dataParams.delivery_date_to * 1000).format('MM-DD-YYYY');

				const result = this.mapBookings(this.dataParams.booking || []);

				this.bookingList.data = result.bookings;
				this.bookingList.total = result.bookings.length;
				this.displayedBooking = [...result.bookings];

				// ✅ SUMMARY TOTALS
				this.dataParams.total_amount = result.total_amount;
				this.dataParams.sub_total = result.sub_total;
				this.dataParams.tax_computation = result.tax_computation;

				
			})
			.catch(err => {
				console.error(err);
				this.$showLoading(false);
			});
		},


	    clearSearch(){
	    	this.dataParams = { 
				origin_id: "", 
				delivery_date_from: "",
				delivery_date_to: "", 
				customer_id:"",
				vendor_id: "",
				depot_id:"",
			}
	    }

 	}, 
}
</script>
